/**
 * Converts a string to a deterministic HSL color.
 *
 * @param str - The input string.
 * @returns A HSL color string like 'hsl(123, 70%, 50%)'.
 *
 */

export function stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 70%, 50%)`;
}
